export default "__VITE_ASSET__BZTZyd8w__"